import React, { useCallback } from 'react'

import { ModelSelect } from 'features/ai/ModelSelect'

type Props = Omit<React.ComponentProps<typeof ModelSelect>, 'value' | 'onChange'> & {
    value?: string | null
    onChange: (value?: string | null) => void
}
export function EditSelectedModel({ value, onChange, style, ...props }: Props) {
    const handleChange = useCallback(
        (value?: string) => {
            onChange(value || null)
        },
        [onChange]
    )

    return (
        <ModelSelect
            label="Model"
            size="m"
            {...props}
            value={value ?? undefined}
            onChange={handleChange}
            style={{ width: 'auto', ...style }}
        />
    )
}
